import { ChangeDetectionStrategy, Component, Injector, ViewChild } from '@angular/core';
import { WidgetBase } from '../../widget-content/base/widget-base';
import { WidgetContentAdvancedTextComponent } from '../../widget-content/advanced-text/advanced-text.component';

@Component({
    selector: 'fi-widget-advanced-text',
    templateUrl: './advanced-text.component.html',
    styleUrls: ['./advanced-text.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-widget-advanced-text' },
    standalone: false,
})
export class WidgetAdvancedTextComponent extends WidgetBase {
    constructor(injector: Injector) {
        super(injector);
    }

    @ViewChild(WidgetContentAdvancedTextComponent, { static: false })
    advancedTextContent: WidgetContentAdvancedTextComponent;

    get isEmpty$() {
        return this.advancedTextContent.isEmpty$;
    }
}
